import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../../assets/images/logo.svg';
import { LOGIN_ROUTE } from '../../../constants/RouteNameConstants';

const TermsAndConditions = () => {
  const navigate = useNavigate();
  return (
    <div className="container">
      <img src={logo} alt="logo" className="cursor-pointer mt-3 logo-img" onClick={() => navigate(LOGIN_ROUTE)} />
      <p style={{ fontSize: '25px', marginTop: '50px' }}>Terms and Conditions</p>
      <p>
        Date of Last revision: <span style={{ color: ' #7A66F0' }}>October, 2022</span>
      </p>
      <p>
        By using Ant by Datagain website ("Company"), all services by Datagain, you ("Contractor") are agreeing to be
        bound by the following terms and conditions ("Freelance Transcription Program Terms and Conditions"), including
        any subsequent changes or modifications to them. If you do not agree to these terms please do not use the Ant by
        Datagain website or services.
      </p>
      <h5>Confidentiality</h5>
      <p>
        Contractor agrees that all Services and Deliverables, and all business, technical, and financial information
        developed, learned, or obtained by or for or on behalf of Contractor while Contractor provides Services that
        relate to Company, its business, or its demonstrably anticipated business or that are received by or for Company
        in confidence constitute "Proprietary Information," including the identity of and information relating to
        Customers or employees. Proprietary Information also includes all information received by the Company in
        confidence from its Customers, suppliers, and other third parties, including without limitation their written
        documents, audio and video files, and resulting translations and transcription.
      </p>
      <p>
        The Contractor shall hold in confidence and not disclose, use, or permit to be used any Proprietary Information,
        except in performing the Services. This provision does not apply to publicly available information.
      </p>
      <p>
        Upon termination of this Agreement, Contractor will return all Proprietary Information to the Company in
        whatever form (including all Deliverables). The Contractor may keep its personal copies of its compensation
        records and this Agreement.
      </p>
      <h5>Delegation</h5>
      <p>
        You acknowledge and agree that you will not delegate the selected assignments to any other person or parties. In
        case of evidence to the contrary, your account may be suspended.
      </p>
      <h5>Legal Name &amp; Address</h5>
      <p>
        You acknowledge and agree that you will provide your legal name and full residential address in your Ant by
        Datagain account. Any incorrect information may lead to account suspension.
      </p>
      <h5>Contractor Warranties</h5>
      <p>Contractor hereby represents, warrants, and agrees that:</p>
      <p>
        1. Contractor is over eighteen (18) years of age or the age of majority in its jurisdiction, whichever is
        greater; of legal age to form a binding contract; not a person barred from providing the Services under the laws
        of its country of residence or any other applicable jurisdiction.
      </p>
      <p>
        2. The information provided by Contractor to Company upon establishing an account, including without limitation
        Contractor's name, address, email address, and state of domicile, shall be true, correct, and complete, and
        Contractor shall update such information in the event of any change thereto.
      </p>
      <p>
        3. The Services contemplated and expressed in this Agreement and in any work project that may be accepted by
        Contractor under this Agreement do not and will not, infringe upon any rights of any third party.
      </p>
      <p>
        4. Contractor has and will maintain all required business registrations, vocational certifications, and other
        licenses required to complete the work it undertakes lawfully and consistent with any legal or professional
        requirements.
      </p>
      <p>
        5. Contractor has, in accordance with applicable law, properly classified all workers who will assist in
        providing Services under this Agreement, if applicable.
      </p>
      <p>6. Contractor will comply with all applicable laws, rules, and regulations.</p>
      <p>
        7. Contractor has the experience and skills to properly perform the Services and will do so in a manner
        consistent with any applicable industry and professional standards.
      </p>
      <h5>Duplicate Accounts</h5>
      <p>
        You acknowledge and agree that you will not create duplicate accounts and/or submit duplicate applications
        and/or delete your account and reapply for the transcription test. In case of evidence to the contrary, your
        account(s) may be suspended.
      </p>
      <h5>Non-transferable</h5>
      <p>
        You acknowledge and agree that your account on Ant by Datagain is non-transferable and you will not sell or
        transfer ownership of your account to other persons or parties. In case of evidence to the contrary, your
        account may be suspended. You may however delete your account anytime you wish.
      </p>
      <h5>Privacy</h5>
      <p>
        You acknowledge and authorize us to collect and store personal information such as cookies, IP addresses, and
        other information which is required for payments, identification, authentication, service improvement, research,
        and contact. We do not sell, rent or share personal information with third parties without your prior consent.
        We may, however, disclose personal information when we believe it violates our terms and conditions or is
        appropriate to comply with the law, to protect our or our users' rights, as well as to protect our users from
        fraudulent, abusive, and unlawful use of the service.
      </p>
      <h5>Dispute Resolution</h5>
      <p>
        You acknowledge and agree that the final decision regarding a review dispute as judged by Ant by Datagain
        administrators is binding and you are willing to accept the decision. Refusal to accept the decision constitutes
        a violation of these Terms and Conditions.
      </p>
      <h5>Minimum Quality Standard</h5>
      <p>
        You acknowledge and agree that you will abide by the minimum quality standard as prescribed in the transcription
        guidelines. Any submissions which do not meet the criteria will be rejected.
      </p>
      <h5>Payments</h5>
      <p>We reserve the right to change our payment rules at our discretion.</p>
      <p>
        Ant by Datagain issues payments via PayPal. You are solely responsible to maintain the correct information
        regarding your PayPal account. In case of non-receipt of payments, you may ask for the transaction id for the
        payment and follow up with PayPal customer service.
      </p>
      <p>
        You acknowledge and agree that we may decline to process a payment request for any reason or withhold it for an
        indefinite time.
      </p>
      <p>For any payment-related issue redressal, you can contact Ant by Datagain.</p>
      <h5>Accounts, passwords, and Security</h5>
      <p>
        You must be a registered user to access the Service. You are responsible for keeping your password secure. You
        will be solely responsible and liable for any activity that occurs under your registered email address.
      </p>
      <h5>Acceptable Use and Conduct</h5>
      <p>
        You are solely responsible for your conduct and your data related to the Service. You agree to indemnify,
        defend, and hold harmless Datagain and its suppliers from any and all loss, cost, liability, and expense arising
        from or related to your data, your use of the Service, or your violation of these terms.
      </p>
      <p>
        Any unauthorized use of any Datagain's Service is a violation of this Agreement and certain federal and state
        laws. Such violations may subject the unauthorized user and his or her agents to civil and criminal penalties.
      </p>
      <p>
        Ant by Datagain has a strict policy on abusive behavior, derogatory language, and threats directed towards
        Datagain, the employees of Datagain, or any users of the Service. Your account may be suspended your attempts to
        contact support will be ignored.
      </p>
      <p>
        Any attempt to contact persons who are directly or indirectly referred to in any particular file is a violation
        of this agreement and may lead to account suspension.
      </p>
      <h5>Limitation of Liability</h5>
      <p>
        In no event shall Datagain be liable for any indirect, special, incidental, consequential, or punitive damages
        (including but not limited to loss of effort, loss of time, loss of use, loss of profits, or loss of data)
        whether in an action in contract, tort (including but not limited to negligence), equity or otherwise, arising
        out of or in any way connected with the use of or inability to use this site or the materials therein or
        resulting from unauthorized access to or alteration of data.
      </p>
      <p>
        You acknowledge and agree that all decisions made by Datagain regarding the use of this site (including
        applications, submissions, disputes, requests, etc.) are final and binding.
      </p>
      <h5>Avoidance of Conflict of Interest</h5>
      <p>
        Contractor represents and warrants that Contractor has no outstanding agreement or obligation that conflicts
        with this Agreement, or that would preclude Contractor from complying with the Agreement, and further certifies
        that Contractor will not enter into such conflicting agreement during the term of this Agreement.
      </p>
      <h5>Termination of Service</h5>
      <p>We reserve the right to suspend your Ant by Datagain account at any time.</p>
      <h5>Conditions</h5>
      <p>
        We may modify or terminate our services at any time, for any reason, and without notice. We reserve the right to
        modify these Terms of Service at any time without notice.
      </p>
      <p>
        Please review these Terms of Service on occasion as they may change in the future. We may, but have no
        obligation to, remove accounts and content containing what we determine as unlawful, offensive, threatening,
        defamatory, obscene, or otherwise objectionable material. We will remove content that violates any party's
        intellectual property or these Terms of Service. An account terminated by Datagain will not be backed up for any
        reason and will be immediately deleted from our servers.
      </p>
      <p className="mb-5">
        Users with questions about this Agreement may contact Ant by Datagain from the contact page.
      </p>
    </div>
  );
};

export default TermsAndConditions;
